import { Box, Stack, Typography, Card } from '@mui/joy';
import type { FunctionComponent } from 'react';
import { OpenInNew } from '@mui/icons-material';
import GButton from '../technical/inputs/GButton/GButton';

const Home: FunctionComponent<{ loggedInNoAccess: boolean }> = ({ loggedInNoAccess = false }) => {
  const handleBookDemoClick = (): void => {
    window.open('https://www.genieai.tech/', '_blank');
  };

  if (loggedInNoAccess) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '80vh',
        }}
      >
        <Card variant="outlined" sx={{ maxWidth: 500, p: 4 }}>
          <Stack spacing={3} alignItems="center">
            <Typography level="h2">Welcome to GenieAI!</Typography>
            <Typography level="title-sm" textAlign="center">
              Thank you for logging in. Unfortunately, you don't have access to this product yet.
            </Typography>
            <Typography level="body-sm" textAlign="center" color="neutral">
              Please book a demo to learn more about GenieAI and how it can help your organization with portfolio
              intelligence, AI-powered research, and operations.
            </Typography>
            <GButton
              color="primary"
              size="lg"
              onClick={handleBookDemoClick}
              endDecorator={<OpenInNew />}
              width="normal"
            >
              Book a Demo
            </GButton>
          </Stack>
        </Card>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        padding: '3rem',
      }}
    >
      <Stack spacing={1.5}>
        <Typography level="h2">Welcome to GenieAI!</Typography>
        <Typography level="title-sm">To proceed to the application, please log in first.</Typography>
      </Stack>
    </Box>
  );
};

export default Home;
